class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButtons = document.querySelectorAll('form[action="/search"] button[type="reset"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.isResetButtonHidden = true;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

      if (this.resetButton.classList.contains("hidden")){
          this.isResetButtonHidden = true
      } else {
          this.isResetButtonHidden = false
      }
  }

  toggleResetButton() {
    if (this.input.value.length > 0 && this.isResetButtonHidden) {
        this.resetButtons.forEach(button => button.classList.remove('hidden'));
        this.isResetButtonHidden = false;
    } else if (this.input.value.length === 0) {
        this.resetButtons.forEach(button => button.classList.add('hidden'));
        this.isResetButtonHidden = true;
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
